"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const TooltipOnOverflow_1 = require("./TooltipOnOverflow");
const H2 = styled_components_1.styled.h2 `
  font-size: 1.3rem;
  margin-top: 0;
  margin-bottom: ${(props) => (props.noMargin ? 0 : props.theme.spacing)};
  font-weight: 400;
  flex: 1;
  white-space: nowrap;
  max-width: 100%;
`;
const SubHeading = ({ children, flexChildren, noMargin, style }) => (react_1.default.createElement(H2, { noMargin, style },
    react_1.default.createElement(TooltipOnOverflow_1.TooltipOnOverflow, { style: flexChildren ? { gap: 10, display: "flex", alignItems: "center" } : {} }, children)));
exports.default = SubHeading;
//# sourceMappingURL=SubHeading.js.map